export default "__VITE_ASSET__CPb5wSOh__"